import { ApiError } from "../api.js";

// Dashboard role widgets (admin org-dashboard / usage, teacher dashboard) are
// fetched per role from endpoints the server gates by role. A student — or any
// user without the role — gets a 403, which is an EXPECTED, non-error outcome:
// the widget just shouldn't render and we stay quiet (no inline error, no
// console noise). Anything else (a 5xx, a network failure, a malformed
// response) IS a real failure the user can retry, so we surface a quiet inline
// error with a Retry. This single classifier keeps that distinction in one
// tested place rather than scattering `e.status === 403` checks across the
// component.
export type WidgetErrorKind = "hide" | "error";

export function classifyWidgetError(err: unknown): WidgetErrorKind {
  // A 403 (or a 401 that slipped through) means "not your widget" — hide it
  // quietly. Everything else is a genuine failure worth a Retry.
  if (err instanceof ApiError && (err.status === 403 || err.status === 401)) {
    return "hide";
  }
  return "error";
}
